<div class="row">
  <div class="col-md-12 pl-4">
      <yt-fw-default-update-buttons #defaultUpdateButtons>
        <div class="mr-2">
          <h2 style="display:inline-block; color: #71b1d1">
              <span *ngIf="baseUpdate.Item.ID <= 0"><span translate="TROSAKDOKUMENT.NEW"></span></span>
              <span *ngIf="baseUpdate.Item.ID > 0">
                  <span translate="TROSAKDOKUMENT.BROJDOKUMENTA.SINGULAR"></span>
                  <span style="padding-left: 5px">{{baseUpdate.Item.BrojDokumenta}}</span>
              </span>
          </h2>
      </div>
      </yt-fw-default-update-buttons>

    </div>
</div>
<yt-trosak-dokument-update #baseUpdate></yt-trosak-dokument-update>